import React from "react";
import { Quote } from "lucide-react";

const quotes = [
  {
    text: "Honestly thought AI was for big companies. iAriya set up a little assistant that handles my evening enquiries. Booked three boilers last weekend without lifting a finger.",
    name: "Dean H.",
    role: "Gas Engineer, Surrey",
    bg: "bg-[var(--yellow)] text-ink",
    rotate: "rotate-[-1deg]",
  },
  {
    text: "Quotes used to take me hours. Now my AI assistant drafts them while I'm still driving home. My partner says I've been a much nicer person since.",
    name: "Marcus T.",
    role: "Painter & Decorator, Birmingham",
    bg: "bg-[var(--pink)] text-white",
    rotate: "rotate-[1.5deg]",
  },
  {
    text: "I run a mobile massage business solo. The booking bot pre-screens clients, takes deposits, and reschedules around traffic. Game changer.",
    name: "Priya K.",
    role: "Massage Therapist, London",
    bg: "bg-[var(--blue)] text-white",
    rotate: "rotate-[-0.8deg]",
  },
  {
    text: "Was sceptical. Two weeks in, the WhatsApp bot booked me a £1,400 patio job at 11pm on a Tuesday. Sold.",
    name: "Tom & Ola",
    role: "Landscapers, Cardiff",
    bg: "bg-white text-ink",
    rotate: "rotate-[1deg]",
  },
];

export const Testimonials = () => {
  return (
    <section
      data-testid="testimonials-section"
      className="border-b-2 border-ink py-24 lg:py-32 bg-[var(--paper)]"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="text-center max-w-3xl mx-auto">
          <p className="uppercase text-sm font-bold tracking-[0.25em] text-[var(--pink)]">
            Kind words
          </p>
          <h2 className="font-display mt-3 text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight">
            From the people who matter most:{" "}
            <span className="text-[var(--blue)]">you lot.</span>
          </h2>
        </div>

        <div className="mt-14 grid md:grid-cols-2 gap-8">
          {quotes.map((q, i) => (
            <div
              key={q.name}
              data-testid={`testimonial-card-${i}`}
              className={`border-2 border-ink rounded-3xl p-8 shadow-brutal ${q.bg} ${q.rotate} relative`}
            >
              <Quote
                className={`absolute top-5 right-5 ${q.bg.includes("text-white") ? "text-white/30" : "text-stone-900/20"}`}
                size={40}
              />
              <p className="text-lg sm:text-xl leading-relaxed font-semibold">
                "{q.text}"
              </p>
              <div className="mt-6 flex items-center gap-3">
                <div className="h-11 w-11 rounded-full border-2 border-ink bg-white text-ink font-display font-black flex items-center justify-center">
                  {q.name.charAt(0)}
                </div>
                <div>
                  <p className="font-bold">{q.name}</p>
                  <p
                    className={`text-sm ${q.bg.includes("text-white") ? "text-white/80" : "text-stone-700"}`}
                  >
                    {q.role}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
